import { CSSProperties } from 'react';

import styles from './RangeSlider.module.css';

type TRangeSliderProps = {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  ariaLabel: string;
  minLabel?: string;
  maxLabel?: string;
};

/**
 * A styled native `<input type="range">` rather than orion's Slider — orion's
 * slider hardcodes its own blue and can't be recoloured without specificity
 * hacks. Reusable across screens that need an amount/range control.
 */
export const RangeSlider = ({
  min,
  max,
  step,
  value,
  onChange,
  ariaLabel,
  minLabel,
  maxLabel,
}: TRangeSliderProps) => {
  const filledPercentage = ((value - min) / (max - min)) * 100;

  return (
    <div>
      <input
        type="range"
        className={styles.slider}
        style={{ '--filled': `${filledPercentage}%` } as CSSProperties}
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label={ariaLabel}
        onChange={(event) => onChange(Number(event.target.value))}
      />
      {(minLabel || maxLabel) && (
        <div className={styles.range}>
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      )}
    </div>
  );
};
